class DetailsDisclosure extends HTMLElement {
  constructor() {
    super(); 
    this.mainDetailsToggle = this.querySelector('details');
    this.header = this.mainDetailsToggle.querySelector('summary');
    this.content = this.mainDetailsToggle.querySelector('div');

    this.header.addEventListener('mouseenter', this.onHeaderMouseEnter.bind(this));
    

    document.querySelector('header').addEventListener('mouseleave',this.closeAll);
    const liNoTargetElements = document.querySelectorAll('.li-no-targer');
    liNoTargetElements.forEach(element => {
      element.addEventListener('mouseenter', this.onLiNoTargetMouseEnter.bind(this));
    });
  }
  onLiNoTargetMouseEnter() {
    this.closeAll();
  }
  onHeaderMouseEnter() {
    this.open();
  }

  onHeaderMouseLeave() {
    this.close();
  }

  onDetailsMouseLeave() {
    this.close();
  }

  open() {
    this.closeAll();
    this.mainDetailsToggle.setAttribute('open', '');
    this.header.setAttribute('aria-expanded', true);
  }
  closeAll() {
    let detailsElements = document.querySelectorAll('details');
    detailsElements.forEach(function (details) {
      details.removeAttribute('open');
    });
  }
  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.header.setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.addEventListener('mouseleave',this.closeAll);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
